<template>
  <div class="masonry">
    <div
      class="masonry-wrap"
      :style="wrapStyles"
      >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { getStyle } from '@/utils/utils';

export default {
  name: 'Masonry',
  props: {
    width: {
      type: Number,
      default: 100
    },
    gutter: {
      type: Number,
      default: 0
    }
  },
  provide() {
    return { masonry: this };
  },
  data() {
    return {
      top: [],
      left: [],

      height: 0
    };
  },
  computed: {
    wrapStyles() {
      const style = {
        height: `${this.height}px`
      };

      return this.gutter === 0
        ? style
        : Object.assign(style, {
          margin: `-${this.gutter / 2}px`
        });
    }
  },
  methods: {
    slotAdd(el, val) {
      this.$nextTick(() => {
        const min = Math.min(...this.top);
        const index = this.top.indexOf(min);
        const top = this.top[index];
        const left = this.left[index];
        const { height } = this;

        el.style.opacity = 1;
        el.style.top = `${top}px`;
        el.style.left = `${left}px`;
        el.style.transform = 'scale(1)';
        el.setAttribute('data-index', index);

        this.top[index] += val;
        this.height = Math.max(height, this.top[index]);
      });
    },
    slotDelete(el, val) {
      const index = el.getAttribute('data-index');
      this.top[index] -= val;
      this.height = Math.max(...this.top);
    }
  },
  mounted() {
    const width = parseInt(getStyle(this.$el, 'width'), 10);
    const columns = Math.floor((width + this.gutter) / this.width);

    for (let i = 0; i < columns; i++) {
      this.top.push(0);
      this.left.push(i * this.width);
    }
  }
};
</script>
